import React, { useEffect } from "react";
import {
  useLocation,
  useParams
} from "react-router-dom";
import { Loader } from "../components/Loader";
import { apiRequest } from "../ApiClient";
// A custom hook that builds on useLocation to parse
// the query string for you.
function useQuery() {
    const { search } = useLocation();
  
    return React.useMemo(() => new URLSearchParams(search), [search]);
  }

export const GoTo = () => {
    const {"*": path} = useParams();
    const params =  Object.fromEntries(useQuery().entries());
    console.log("path", path, "params", params);
    const redirect = async () => {
      let resp = await apiRequest("/" + path, params);
      if (resp.ok) {
        const data = await resp.json();
        window.location.href = data.redirect_url;
      } else {
        throw resp.json();
      }
    };
    useEffect(() => {
      redirect();
    }, []);
    return <Loader/>
}